import request from '@/utils/request_api';
import request_yin from '@/utils/request_yin';
import Axios from 'axios';

const domain = process.env.api;
const domains = process.env.yins;
const apiUrl = process.env.apinew;
// const domain = '/yin';
// 用户信息
export function req_userInfo(useid) {
	const data = {
		method: 'POST',
		data: {
			useid: useid
		}
	}
	return request(domain + '/newlogin/getuserinfo', data);
}
// 用户财务列表
export function req_caiwuList(uid, page, pageSize, displayStartDate, displayEndDate) {
	const data = {
		method: 'POST',
		data: {
			uid: uid,
			page: page,
			pageSize: pageSize,
			displayStartDate: displayStartDate,
			displayEndDate: displayEndDate,
		}
	}
	return request(domain + '/userCaiWu/userCaiWuList', data);
}
export function req_caiwuList1(uid, page, pageSize, displayStartDate, displayEndDate, type) {
	const data = {
		uid: uid,
		page: page,
		pageSize: pageSize,
		start: displayStartDate,
		end: displayEndDate,
		type: type,
	};

	return new Promise((resolve, reject) => {
		let result = {
			success: false,
			data: false,
			msg: '',
		}
		const config = {
			headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
		};
		Axios.get(domains + '/caihang/UserCaiWu_List', { params: data }).then((r) => {
			if (r.status === 200) {
				result.success = true;
				result.data = r.data;
				resolve(result);
			} else {
				console.log('========================= user.js');
				console.log(r);
				resolve(result);
			}
		}).catch((e) => {
			console.log('request catch ==================');
			if (e.toString() === 'Error: timeout of 10000ms exceeded') {
				result.msg = '请求超时, 请检查网络状况重新操作';
			} else {
				result.msg = e;
			}
			resolve(result);
		});
	})
}
export function UserCaiWu_Export(uid, page, pageSize, displayStartDate, displayEndDate, type) {
	const data = {
		uid: uid,
		page: page,
		pageSize: pageSize,
		start: displayStartDate,
		end: displayEndDate,
		type: type,
	};

	return new Promise((resolve, reject) => {
		let result = {
			success: false,
			data: false,
			msg: '',
		}
		const config = {
			headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
		};
		Axios.get(domains + '/caihang/UserCaiWu_Export', { params: data }).then((r) => {
			if (r.status === 200) {
				result.success = true;
				result.data = r.data;
				resolve(result);
			} else {
				console.log('========================= user.js');
				console.log(r);
				resolve(result);
			}
		}).catch((e) => {
			console.log('request catch ==================');
			if (e.toString() === 'Error: timeout of 10000ms exceeded') {
				result.msg = '请求超时, 请检查网络状况重新操作';
			} else {
				result.msg = e;
			}
			resolve(result);
		});
	})
}
// 用户预存款、信用额度
export function req_userDeposit(userid) {
	const data = {
		method: 'POST',
		data: {
			userid: userid
		}
	}
	return request(domain + '/order/getmoney', data);
}

// 今日订单状态
export function req_orderFlag(uid) {
	const data = {
		method: 'POST',
		data: {
			uid: uid
		}
	}
	return request(domain + '/order/getYinOrderFlag', data);
}

// 今日下单条数
export function req_orderCount(uid) {
	const data = {
		method: 'POST',
		data: {
			uid: uid
		}
	}
	return request(domain + '/order/getyinOrderCount', data);
}

// 修改密码
export function req_updatePassword(userid, oldPassword, newPassword) {
	const data = {
		method: 'POST',
		data: {
			userid: userid,
			oldPassword: oldPassword,
			newPassword: newPassword
		}
	}
	return request(domain + '/newlogin/updatePassword', data);
}

export function req_validatecode(code) {
	const data = {
		code: code

	};

	return new Promise((resolve, reject) => {
		let result = {
			success: false,
			data: false,
			msg: '',
		}
		const config = {
			headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
		};
		Axios.get(apiUrl + '/api/Users/ValidateCode', { params: data }).then((r) => {
			if (r.status === 200) {
				result.success = true;
				result.data = r.data;
				resolve(result);
			} else {
				console.log('========================= user.js');
				console.log(r);
				resolve(result);
			}
		}).catch((e) => {
			console.log('request catch ==================');
			if (e.toString() === 'Error: timeout of 10000ms exceeded') {
				result.msg = '请求超时, 请检查网络状况重新操作';
			} else {
				result.msg = e;
			}
			resolve(result);
		});
	})
}

// 修改用户资料
export function req_updateuserinfo(userid, tel, email, qq) {
	var postValue = {
		key: userid, values: {
			Tel: tel,
			Email: email,
			QQ: qq,
		}
	};
	const strPost = JSON.stringify(postValue);
	return new Promise((resolve, reject) => {
		let result = {
			success: false,
			data: false,
			msg: '',
		}
		const config = {
			headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
		};
		Axios.post(apiUrl + '/api/Users/UpdateUserInfo', strPost, config).then((r) => {
			if (r.status === 200) {
				result.success = true;
				resolve(result);
			} else {
				console.log('========================= user.js');
				console.log(r);
				resolve(result);
			}
		}).catch((e) => {
			console.log('request catch ==================');
			if (e.toString() === 'Error: timeout of 10000ms exceeded') {
				result.msg = '请求超时, 请检查网络状况重新操作';
			} else {
				result.msg = e;
			}
			resolve(result);
		});
	})
}
// 用户登陆
export function req_userLogin(message, userword) {
	const data = {
		method: 'POST',
		data: {
			message: message,
			userword: userword,
		}
	}
	return request(domain + '/newlogin/login', data);
}

// 用户收货地址列表
export function req_userAddressList(userId) {
	const data = {
		method: 'POST',
		data: {
			userId: userId,
		}
	}
	return request(domain + '/order/getaddressbyuserid', data);
}

// 添加收货地址
export function req_userAddressCreate(userid, Address, Attn, Company, Mobile, province, city, area) {
	const data = {
		method: 'POST',
		data: {
			userid: userid,//前端获取名字
			Address: Address,//手机号
			Attn: Attn,//联系人
			Company: Company,//公司名称
			Mobile: Mobile,//公司名称
			province: province,
			city: city,
			area: area,
		}
	}
	return request(domain + '/order/newaddress', data);
}

// 设置默认地址
export function req_userAddressSetDefault(id, userid) {
	const data = {
		method: 'POST',
		data: {
			id: id,//id
			userid: userid,
		}
	}
	return request(domain + '/order/updateaddressdefault', data);
}

// 编辑地址
export function req_userAddressSetModify(id, Address, province, city, area, name, company, phone) {
	const data = {
		method: 'POST',
		data: {
			id: id,//id
			Address: Address,//地址详细
			province: province,//省
			city: city,//市
			area: area,//区
			rsrvstr1: name,//联系人
			rsrvstr2: company,//公司名称
			rsrvstr4: phone,//手机号
		}
	}
	return request(domain + '/order/updateaddress', data);
}

// 获取用户会员报价利率
export function req_userMemberRate(uid) {
	const data = {
		method: 'POST',
		data: {
			uid: uid,
		}
	}
	return request(domain + '/quote/memberRate', data);
}

// 用户注册
export function req_register(obj) {
	const data = {
		method: 'POST',
		data: {
			UserWord: obj.UserWord,	//密码
			Mobile: obj.Mobile,		//手机号	
			fullName: obj.fullName,  //公司全称
			Company: obj.Company,	//公司简称
			Attn: obj.Attn,	//联系人
			province: obj.province,//区域
			city: obj.city,
			area: obj.area,
			Address: obj.Address,//详细地址
			//sendmode: obj.sendmode, //送货方式
			QQ: obj.QQ,				//QQ
			Tel: obj.Tel, //收货人手机号
			DesignerTel: obj.DesignerTel, //设计师手机号码
			Binding2: obj.Binding2, //用户ID
			Email: '',
			PostalCode: obj.sendmode,
			personInchargeTel: '',
			Binding1: obj.sendmode,//送货方式
		}
	}
	return request(domain + '/newlogin/register', data);
}
// 找回密码表单
export function ChangePassword(phone, newpassword, code) {
	return new Promise((resolve, reject) => {
		let data = {
			phone: phone,
			newpassword: newpassword,
			code: code
		}
		const config = {
			headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
		};
		Axios.get(domains + '/Caihang/ChangePassword', { params: data }).then((result) => {
			if (result.status === 200) {
				result.success = true;
				resolve(result);
			} else {
				console.log('========================= user.js');
				console.log(r);
				resolve(result);
			}
		}).catch((e) => {
			if (e.toString() === 'Error: timeout of 10000ms exceeded') {
				e.msg = '请求超时, 请检查网络状况重新操作';
			} else {
				e.msg = e;
			}
			resolve(e);
		});
	})
}
//找回密码发送验证码
export function SendRecoveryCode(phone) {
	return new Promise((resolve, reject) => {
		let data = {
			phone: phone,
		}
		const config = {
			headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
		};
		Axios.get(domains + '/Caihang/SendRecoveryCode', { params: data }).then((result) => {
			if (result.status === 200) {
				result.success = true;
				resolve(result);
			} else {
				console.log('========================= user.js');
				console.log(r);
				resolve(result);
			}
		}).catch((e) => {
			if (e.toString() === 'Error: timeout of 10000ms exceeded') {
				e.msg = '请求超时, 请检查网络状况重新操作';
			} else {
				e.msg = e;
			}
			resolve(e);
		});
	})
}

// 发送短信验证码
export function req_sendsms(phone, code) {
	return new Promise((resolve, reject) => {
		let data = {
			phone: phone,
			code: code,
		}
		const config = {
			headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
		};
		Axios.get(domains + '/Caihang/SendSMS', { params: data }).then((result) => {
			if (result.status === 200) {
				result.success = true;
				resolve(result);
			} else {
				console.log('========================= user.js');
				console.log(r);
				resolve(result);
			}
		}).catch((e) => {
			if (e.toString() === 'Error: timeout of 10000ms exceeded') {
				e.msg = '请求超时, 请检查网络状况重新操作';
			} else {
				e.msg = e;
			}
			resolve(e);
		});
	})
}
// 发送短信校验码
export function req_code(phone) {
	return new Promise((resolve, reject) => {
		let data = {
			phone: phone,
		}
		const config = {
			headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
		};
		Axios.get(domains + '/Caihang/SendManageCode', { params: data }).then((result) => {
			if (result.status === 200) {
				result.success = true;
				resolve(result);
			} else {
				console.log('========================= user.js');
				console.log(r);
				resolve(result);
			}
		}).catch((e) => {
			if (e.toString() === 'Error: timeout of 10000ms exceeded') {
				e.msg = '请求超时, 请检查网络状况重新操作';
			} else {
				e.msg = e;
			}
			resolve(e);
		});
	})
}
export function req_check(phone, code) {
	return new Promise((resolve, reject) => {
		let data = {
			phone: phone,
			code: code
		}
		const config = {
			headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
		};
		Axios.get(domains + '/Caihang/ValidateManageCode', { params: data }).then((result) => {
			if (result.status === 200) {
				result.success = true;
				resolve(result);
			} else {
				console.log('========================= user.js');
				console.log(r);
				resolve(result);
			}
		}).catch((e) => {
			if (e.toString() === 'Error: timeout of 10000ms exceeded') {
				e.msg = '请求超时, 请检查网络状况重新操作';
			} else {
				e.msg = e;
			}
			resolve(e);
		});
	})
}
// 用户利率设置
export function req_customer(uid) {
	return new Promise((resolve, reject) => {
		let data = {
			uid: uid,
		}
		const config = {
			headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
		};
		Axios.get(domains + '/caihang/GetCustomerProfit', { params: data }).then((result) => {
			if (result.status === 200) {
				result.success = true;
				resolve(result);
			} else {
				console.log('========================= user.js');
				console.log(r);
				resolve(result);
			}
		}).catch((e) => {
			if (e.toString() === 'Error: timeout of 10000ms exceeded') {
				e.msg = '请求超时, 请检查网络状况重新操作';
			} else {
				e.msg = e;
			}
			resolve(e);
		});
	})
}


// WEBPACK FOOTER //
// ./src/services/user.js